import { OrderedMap } from "immutable"

import PendingRequest from "common/records/PendingRequest"
import { STATUS } from "../../../components/BookingPendingRequests/consts/pendingRequestConsts"
import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"

// eslint-disable-next-line consistent-return
export default function(requests = []) {
  try {
    return requests
      .filter(request => request.status === STATUS.PENDING)
      .reduce((acc, x) => acc.set(x.id, new PendingRequest(x)), OrderedMap())
  } catch (err) {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_PENDING_REQUESTS_UNSUPPORTED_FORMAT, {
      requests,
      err,
    })
  }
}
